<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_VIEW_DATA')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thanh toán T+2</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          type="button"
          class="f12 font-medium btn btn-outline-secondary"
          v-show="
            selected.length > 0 && dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_ASSIGN_USER')
          "
          @click="showAssignList(selected)"
        >
          Gán NV xử lý
        </button>
        <button
          type="button"
          class="f12 font-medium btn btn-outline-secondary"
          v-show="
            selected.length > 0 && dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_SELF_ASSIGN')
          "
          @click="assignToMe(selected)"
        >
          Nhận việc
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian thanh toán
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input v-model.trim="filter.key" placeholder="Tên/Email/SĐT" />
          </div>
          <div class="form-group">
            <input v-model.trim="filter.transactionTxnId" placeholder="ID giao dịch" />
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="filter.paymentMethod"
              :options="optionPaymentMethod"
              :settings="{ placeholder: 'Phương thức thanh toán', multiple: false }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              @change="changeFilterAmount"
              :options="optionAmounts"
              :settings="{ placeholder: 'Số tiền', multiple: false }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="filter.riskType"
              :options="optionTypeRisk"
              :settings="{ placeholder: 'Loại rủi ro', multiple: false }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="filter.transactionStatus"
              :options="optionTransStt"
              :settings="{ placeholder: 'Trạng thái giao dịch' }"
            >
            </select2-multiple-control>
          </div>
          <div class="form-group">
            <Select2
              v-model="filter.isAnnounced"
              :options="optionLicenceStt"
              placeholder="Trạng thái"
            >
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng yêu cầu</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataTable"
              :fields="filterTable"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    v-model="selectAll"
                    id="selectedLs"
                  />
                  <label class="custom-control-label" for="selectedLs"></label>
                </div>
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox v-model="selected" :value="data.item.licenceId"></b-form-checkbox>
              </template>
              <template #cell(index)="data">
                {{ (search.pageIndex - 1) * search.pageSize + (data.index + 1) }}
              </template>
              <template #cell(time)="data">
                <p><b>Tạo</b>: {{ data.item.createdTime }}</p>
                <p><b>Cập nhật</b>: {{ data.item.updateAt | formatDate('DD/MM/YYYY HH:mm:ss') }}</p>
                <p v-if="data.item.transInfo.approvedAt">
                  <b>Duyệt</b>: {{ data.item.transInfo.approvedAt }}
                </p>
                <p><b>Thanh toán</b>: {{ data.item.transInfo && data.item.transInfo.tranDate }}</p>
              </template>
              <template #cell(amount)="data">
                {{ data.item.transInfo && data.item.transInfo.amount | transformMoney }}
              </template>
              <template #cell(merchant)="data">
                {{ data.item.merchantInfo.name }}
              </template>
              <template #cell(saleAssign)="data">
                <div v-if="data.item.assigneeInfo.name">
                  {{ data.item.assigneeInfo.name }} <br />
                  <span class="text-primary">{{ data.item.assigneeInfo.email }}</span>
                </div>
              </template>
              <template #cell(nameTrans)="data">
                {{ data.item.transInfo.holderName }}
              </template>
              <template #cell(idTrans)="data">
                {{ data.item.transInfo.tranTxnId }}
              </template>
              <template #cell(sttTrans)="data">
                {{ data.item.transInfo.status | transformData(optionTransStt) }}
              </template>
              <template #cell(paymentMethodText)="data">
                {{ data.item.transInfo.paymentMethodText }}
              </template>
              <template #cell(status)="data">
                <b-badge v-if="data.item.announced" pill variant="success">Đã thông báo</b-badge>
                <b-badge v-else pill variant="warning">Chưa thông báo</b-badge>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="toDetail(data.item)">Chi tiết </b-dropdown-item>
                  <b-dropdown-item
                    @click="updateResultMC(data.item)"
                    v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_SUPPORT_T2')"
                    >Cập nhật tình trạng
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="$router.push('/calendar-afs/create')"
                    v-if="dataPermission.includes('CNPS_CALENDAR_AFS_INSERT')"
                    >Tạo công việc chăm sóc
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="showAssignList([data.item.licenceId])"
                    v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_ASSIGN_USER')"
                    >Gán NV xử lý
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="assignToMe([data.item.licenceId])"
                    v-if="dataPermission.includes('CNPS_CALENDAR_WK_LICENSE_SELF_ASSIGN')"
                    >Nhận việc
                  </b-dropdown-item>
                  <b-dropdown-item @click="checkStatus(data.item.licenceId)"
                    >Kiểm tra TT Thanh toán
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.pageIndex"
          :total-rows="pagination.total"
          :per-page="search.pageSize"
        ></b-pagination>
      </div>
    </div>
    <!--Cập nhật tình trạng-->
    <b-modal id="update-result" v-model="updateResultModal">
      <template #modal-header="{}">
        <h5>Xác nhận đã thông báo cho MC</h5>
        <b-button size="sm" variant="light" @click="resetFormResult"> x </b-button>
      </template>
      <div>
        <ValidationObserver class="w-100" ref="formResult">
          <form @submit.prevent="submitUpdate">
            <ValidationProvider rules="required" vid="method" name="Hình thức thông báo">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Hình thức thông báo<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <Select2 v-model="updateResult.method" :options="optionMethods"></Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="supportAt" name="Ngày thông báo">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Ngày thông báo<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <date-picker
                    format="dd/MM/yyyy"
                    v-model="supportAt"
                    :config="optionsDatePicker"
                  ></date-picker>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required" vid="result" name="Kết quả">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Kết quả<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <Select2 :options="optionResult" v-model="updateResult.result"></Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="minMaxName_4" vid="note" name="Ghi chú">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label">Ghi chú</label>
                <div class="col-sm-8">
                  <input v-model.trim="updateResult.note" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <template #modal-footer="{}">
        <b-button variant="light" @click="resetFormResult"> Đóng </b-button>
        <b-button variant="primary" @click="submitUpdate"> Xác nhận </b-button>
      </template>
    </b-modal>

    <!--gán nhân viên-->
    <b-modal id="assign-modal">
      <template #modal-header="{ close }">
        <h5>Gán nhân viên xử lý</h5>
        <b-button size="sm" variant="outline-light" @click="close()">x</b-button>
      </template>

      <template #default="{}">
        <div class="form-group row">
          <div class="col-sm-12">
            <b-input-group>
              <b-form-input
                placeholder="Tên/Email"
                v-model="searchSale.textSearch"
                @input="listStaff"
                @keyup.enter="listStaff"
              >
              </b-form-input>
              <b-input-group-append>
                <b-button variant="outline-secondary">Tìm kiếm</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="table-responsive m-3" style="max-height: 50vh; overflow-y: auto">
            <b-table
              hover
              :items="dataSale"
              :fields="fields"
              :sticky-header="true"
              class="b-table-select-single"
              id="table-sale"
              selectable
              select-mode="single"
              @row-selected="onStaffSelected"
              :per-page="searchSale.limit"
              :current-page="searchSale.page"
              small
            >
            </b-table>
          </div>
          <b-pagination
            class="ml-3"
            v-model="searchSale.page"
            :total-rows="total"
            :per-page="searchSale.limit"
            aria-controls="table-sale"
          ></b-pagination>
        </div>
      </template>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="primary" @click="assignToSale" :disabled="idAssign === ''">
          Xác nhận
        </b-button>
        <b-button size="sm" variant="light" @click="cancel()"> Huỷ </b-button>
      </template>
    </b-modal>

    <!-- Modal thông báo-->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import { LicenceService } from '@/services/licence.service'
  import { StaffService } from '@/services/staff.service'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  import datePicker from 'vue-bootstrap-datetimepicker'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

  const fieldsTable = [
    { key: 'selected', label: '' },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian' },
    { key: 'amount', label: 'Số tiền' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'saleAssign', label: 'NV xử lý' },
    { key: 'nameTrans', label: 'Tên chủ thẻ' },
    { key: 'idTrans', label: 'ID giao dịch', class: 'text-center' },
    { key: 'sttTrans', label: 'Trạng thái giao dịch' },
    { key: 'paymentMethodText', label: 'Phương thức thanh toán' },
    { key: 'riskTypeText', label: 'Loại rủi ro' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        showLoading: false,
        loading: false,
        filter: {},
        search: {
          pageIndex: 1,
          pageSize: 20,
        },
        pagination: {
          total: 0,
        },
        dataTable: [],
        selected: [],
        fieldsTable,
        filterTable: fieldsTable,
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        optionTypeTrans: Config.typeTransaction,
        optionTypeRisk: Config.typeRisk,
        optionTransStt: Config.transactionStt,
        optionLicenceStt: [
          { id: 0, text: 'Tất cả' },
          { id: true, text: 'Đã thông báo' },
          { id: false, text: 'Chưa thông báo' },
        ],
        optionPaymentMethod: Config.paymentMethods,
        optionAmounts: Config.optionAmounts,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        updateResultModal: false,
        optionMethods: Config.methodT2,
        optionsDatePicker: {
          format: 'DD/MM/YYYY HH:mm',
          useCurrent: true,
        },
        optionResult: Config.resultT2,
        supportAt: null,
        updateResult: {},
        idUpdateResult: '',
        dataSale: [],
        fields: [
          {
            label: 'Tên',
            key: 'name',
            thStyle: { 'min-width': '140px', 'word-break': 'break-word' },
          },
          { label: 'Email', key: 'userName' },
          { label: 'Tỉnh/Thành phố', key: 'provinceName' },
        ],
        idAssign: '',
        searchSale: {
          limit: 20,
          page: 1,
          userId: JSON.parse(localStorage.getItem('userData')).userId,
        },
        total: 0,
        idAssignLicence: [],
      }
    },
    components: {
      DateRangePicker,
      datePicker,
    },
    mixins: [prepareQueryParamsMixin],
    watch: {
      'search.pageIndex': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'searchSale.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList1,
        })
        this.listStaff()
      },
    },
    computed: {
      selectAll: {
        get: function () {
          return this.selected.length === this.dataTable.length
        },
        set: function (value) {
          var selected = []
          if (value) {
            selected = this.dataTable.map(item => item.licenceId)
          }
          this.selected = selected
        },
      },
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList1() {
        return this.prepareQueryParamsMixin({
          limit: this.searchSale.limit,
          page: this.searchSale.page,
        })
      },
    },
    created() {
      this.fetchData()
      this.listStaff()
    },
    methods: {
      changeFilterAmount(val) {
        const spl = val.split('-')
        if (spl.length > 0) {
          if (spl[1] === 'max') {
            delete this.filter.toAmount
            this.filter.fromAmount = Number(spl[0])
          } else {
            this.filter.fromAmount = Number(spl[0])
            this.filter.toAmount = Number(spl[1])
          }
        }
      },
      async checkStatus(id) {
        try {
          this.showLoading = true
          const response = await LicenceService.checkStatus(id)
          this.showSuccessMx(`Trạng thái thông tin: ${response.data.statusText}`)
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      showAssignList(arr) {
        this.$bvModal.show('assign-modal')
        this.idAssignLicence = arr
      },
      onStaffSelected(item) {
        this.idAssign = item.length > 0 ? item[0].userId : ''
      },
      async listStaff() {
        try {
          const data = await StaffService.getListLowerGrade(this.searchSale)
          if (data.success) {
            this.total = data.data.length
            this.dataSale = data.data
          }
        } catch (error) {
          console.log(error)
        }
      },
      async assignToSale() {
        try {
          this.$bvModal.hide('assign-modal')
          this.showLoading = true
          const data = await LicenceService.assignSale({
            licenceIds: this.idAssignLicence,
            userId: this.idAssign,
            isSelfAssign: false,
          })
          if (data.success) {
            this.successModal('Gán nhân viên xử lý thành công')
            this.selected = []
            await this.fetchData()
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },
      async assignToMe(licenceIds) {
        try {
          this.showLoading = true
          const data = await LicenceService.assignSelf({
            licenceIds,
            userId: this.searchSale.userId,
            isSelfAssign: true,
          })
          if (data.success) {
            this.successModal('Nhận việc thành công')
            this.selected = []
            await this.fetchData()
          } else {
            this.errorModal(data.message)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.showLoading = false
        }
      },
      updateResultMC(item) {
        this.updateResultModal = true
        this.idUpdateResult = item.licenceId
      },
      transfromDate() {
        this.filter.fromDate = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.filter.toDate = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      async submitUpdate() {
        try {
          this.updateResult.supportAt = moment(
            this.supportAt,
            this.optionsDatePicker.format
          ).valueOf()
          const isSuccess = await this.$refs.formResult.validate()
          if (!isSuccess) {
            return
          }
          this.showLoading = true
          this.updateResult.licenceId = [this.idUpdateResult]
          const data = await LicenceService.changeResult(this.updateResult)
          if (data.success) {
            this.resetFormResult()
            this.successModal('Cập nhật tình trạng thành công')
            await this.fetchData()
            this.supportAt = null
          } else {
            this.resetFormResult()
            this.errorModal(data.message)
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
      resetFormResult() {
        this.updateResultModal = false
        this.updateResult = {}
        // this.$refs.formResult.reset()
      },
      successModal(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = msg
      },
      errorModal(msg) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = msg
      },
      async fetchData() {
        try {
          this.loading = true
          if (this.filter.isAnnounced === 0) {
            delete this.filter.isAnnounced
          }
          this.search.filter = this.filter
          const data = await LicenceService.listT2(this.search)
          if (data.success) {
            this.dataTable = data.data
            this.pagination.total = data.totalPage.total
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.pageIndex = 1
        this.fetchData()
      },
      async removeForm() {
        this.filter = {}
        this.search = {
          pageSize: 20,
          pageIndex: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      toDetail(item) {
        window.open(`/payment-T2/${item.licenceId}`, '_blank')
      },
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
  }
</script>
